import { createSelector } from "@ngrx/store";
import { selectUiState } from "../reducers";
import * as fromUi from "../reducers/ui.reducer";

export const selectIsSidenavActive = () =>
  createSelector(selectUiState, fromUi.selectIsSidenavActive);
